/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import RoleService from "../../services/roleService";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const RoleDropdown = ({
    helperText,
    error,
    setFormValues,
    isFilter,
    selectedRole,
    setSelectedRole,
    disableSuperAdmin = false
}) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [roles, setRoles] = useState([]);

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const data = await RoleService.fetchAll();
                setRoles(data);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchRoles();
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={roles}
                getOptionLabel={(option) => option.name || ""}
                value={selectedRole}
                onChange={(event, newValue) => {
                    setSelectedRole(newValue);
                    setFormValues &&
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            roleId: newValue ? newValue.id : null,
                        }));
                }}
                renderOption={(props, option) => (
                    <li
                        {...props}
                        key={option.id}
                        style={{
                            color: option.superAdmin && disableSuperAdmin ? theme.palette.text.disabled : "",
                            pointerEvents: option.superAdmin && disableSuperAdmin ? "none" : "auto",
                        }}
                    >
                        {option.name}
                    </li>
                )}
                renderInput={(params) => (
                    <Box>
                        {!isFilter && (
                            <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("role")}
                            </p>
                        )}

                        <TextField
                            {...params}
                            variant={isFilter ? "standard" : "outlined"}
                            fullWidth
                            placeholder={isFilter ? t("role") : t("chooseRole")}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter
                                        ? "transparent"
                                        : theme.palette.customGrey.insideInput,
                                    padding: "6px 8px",
                                    direction: 'unset'
                                },
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor:
                                            theme.palette.customGrey.borderInput,
                                    },
                                    "&:hover fieldset": {
                                        borderColor:
                                            theme.palette.customGrey.borderInput,
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: theme.palette.text.primary,
                                    padding: "6px 8px",
                                    "&::placeholder": {
                                        fontSize: "14px",
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>

    );
};

export default RoleDropdown;
